import { Dispatch } from 'react';

import moment from 'moment';

import { IReducerAction } from '../../../../Hooks/Context/connect';

import { Steps, MIN_AGE, MAX_AGE, PERIODS } from '../Constants';
import { multipleActions, Types as TypesContainer } from './ContainerReducer';
import { TAuthPartialState, IAuthPartialReducer } from './Reducers';


enum Types {
    CLEAN_ERRORS = 'SIGNUP:CLEAN_ERRORS',
    CHANGE_KEYDOW = 'SIGNUP:CHANGE_KEYDOW',
    RESET_KEYDOW = 'SIGNUP:RESET_KEYDOW',
    OPEN_DATE_PICKER = 'SIGNUP:OPEN_DATE_PICKER',
    CHANGE_HOUR_DATA = 'SIGNUP:CHANGE_HOUR_DATA',
    CHANGE_DATE_DATA = 'SIGNUP:CHANGE_DATE_DATA',
    CHANGE_CITY_STATE = 'SIGNUP:CHANGE_CITY_STATE',
    CHANGE_TIME_STATE = 'SIGNUP:CHANGE_TIME_STATE',
    CHANGE_PLACE_DATA = 'SIGNUP:CHANGE_PLACE_DATA',
    CHANGE_WITHOUT_HOUR = 'SIGNUP:CHANGE_WITHOUT_HOUR',
    CHANGE_PERSONAL_DATA = 'SIGNUP:CHANGE_PERSONAL_DATA',
    CHANGE_LOGIN_LOADING = 'SIGNUP:CHANGE_LOGIN_LOADING',
    CHANGE_SIGNUP_LOADING = 'SIGNUP:CHANGE_SIGNUP_LOADING',
    CHANGE_DATE_PICKER_STATE = 'SIGNUP:CHANGE_DATE_PICKER_STATE',
    CHANGE_PERSONAL_FIELD_DATA = 'SIGNUP:CHANGE_PERSONAL_FIELD_DATA',
    CHANGE_PERSONAL_DATA_RESET = 'SIGNUP:CHANGE_PERSONAL_DATA_RESET'
}

interface IKeyDown {
    key: string,
    updatedAt: number | null,
}

interface ICity {
    description: string,
    place_id: string,
    structured_formatting: {
        main_text: string,
        secondary_text: string,
    }
}

interface IInputData {
    error: string,
    value?: string,
    touched: boolean
}

interface IInputDataEmail extends IInputData {
    loading: boolean,
    sugestion: string,
}

interface IInputDataPassword extends IInputData {
    visiblePassword: boolean,
}

interface IBirthDateState {
    error: string,
    touched: boolean,
    displayDate: string,
    minDate: moment.Moment,
    maxDate: moment.Moment,
    openDatePicker: boolean,
    date: moment.Moment | null,

    datePickerState: {
        years: [],
        months: [],
        selectedDay: string,
        selectedYear: string,
        selectedMonth: string,
        datePickerDate: moment.Moment | null,
    }
}

interface IBirthHourState {
    error: string,
    selectedHour: string,
    openTimePicker: boolean,

    timeState: {
        hour: string,
        minute: string,
        touched: boolean,
        inputTime: boolean,
        period: string,
    }
}

interface IPersonalDataState {
    name: IInputData,
    checkField: string,
    gender: IInputData,
    consentTerms: boolean,
    email: IInputDataEmail,
    referencing: IInputData,
    emailSubscription: boolean,
    password: IInputDataPassword,
}

interface IAuthStateSignUp extends TAuthPartialState {
    checkedWithoutHour: boolean,
    loginButtonLoading: boolean,
    signUpButtonLoading: boolean,

    keyDown: IKeyDown,

    birthData: {
        birthDate: IBirthDateState,

        birthHour: IBirthHourState,

        birthPlace: {
            error: string,
            place: ICity,

            cityState: {
                cities: ICity[],
                hoverItem: number,
                loading: boolean,
                touched: boolean,
                blurTimeout: number | null,
                cityDescription: string,
                showSugestions: boolean,
            }
        }
    },

    personalData: IPersonalDataState
}

interface IAuthSignUpReducer extends IAuthPartialReducer {
    (action: IReducerAction, state: { SignUp: IAuthStateSignUp }): void;
}

interface IChangeFieldAction extends IReducerAction {
    field: string,
}

const monthsArray = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
];

const initialState: { SignUp: IAuthStateSignUp } = {
    SignUp: {
        checkedWithoutHour: false,
        loginButtonLoading: false,
        signUpButtonLoading: false,

        keyDown: {
            key: '',
            updatedAt: null
        },

        birthData: {
            birthDate: {
                date: null,
                error: '',
                touched: false,
                displayDate: '',
                openDatePicker: false,
                minDate: moment().subtract(MIN_AGE, 'years'),
                maxDate: moment().subtract(MAX_AGE, 'years'),

                datePickerState: {
                    years: [],
                    months: [],
                    selectedDay: '',
                    selectedYear: '',
                    selectedMonth: '',
                    datePickerDate: null
                }
            },

            birthHour: {
                error: '',
                selectedHour: '',
                openTimePicker: false,
                timeState: {
                    hour: '',
                    minute: '',
                    touched: false,
                    inputTime: false,
                    period: PERIODS.AM
                }
            },

            birthPlace: {
                error: '',

                place: {
                    place_id: '',
                    description: '',

                    structured_formatting: {
                        main_text: '',
                        secondary_text: ''
                    }
                },

                cityState: {
                    cities: [],
                    hoverItem: 0,
                    loading: false,
                    touched: false,
                    blurTimeout: null,
                    cityDescription: '',
                    showSugestions: false
                }
            }
        },

        personalData: {
            checkField: '',
            consentTerms: false,
            emailSubscription: false,

            name: {
                value: '',
                error: '',
                touched: false
            },

            email: {
                value: '',
                error: '',
                sugestion: '',
                loading: false,
                touched: false
            },

            gender: {
                error: '',
                touched: false,
                value: undefined
            },

            password: {
                value: '',
                error: '',
                touched: false,
                visiblePassword: false
            },

            referencing: {
                error: '',
                touched: false,
                value: undefined
            }
        }
    }
};

const SignUpReducer: IAuthSignUpReducer = (action, state = initialState) => {
    switch (action.type) {
        case Types.CHANGE_WITHOUT_HOUR:
            return {
                ...state,
                SignUp: {
                    ...state.SignUp,
                    checkedWithoutHour: action.data,
                    birthData: {
                        ...state.SignUp.birthData,
                        birthHour: {
                            ...state.SignUp.birthData.birthHour,
                            error: '',
                            selectedHour: ''
                        }
                    }
                }
            };

        case Types.CHANGE_KEYDOW:
            return {
                ...state,
                SignUp: {
                    ...state.SignUp,
                    keyDown: action.data
                }
            };

        case Types.RESET_KEYDOW:
            return {
                ...state,
                SignUp: {
                    ...state.SignUp,
                    keyDown: {
                        ...state.SignUp.keyDown,
                        key: null
                    }
                }
            };

        case Types.CHANGE_LOGIN_LOADING:
            return {
                ...state,
                SignUp: {
                    ...state.SignUp,
                    loginButtonLoading: action.data
                }
            };

        case Types.CHANGE_SIGNUP_LOADING:
            return {
                ...state,
                SignUp: {
                    ...state.SignUp,
                    signUpButtonLoading: action.data
                }
            };

        case Types.CHANGE_PLACE_DATA:
            if (!action.data.place || Object.keys(action.data.place).length === 0) return state;

            return {
                ...state,
                SignUp: {
                    ...state.SignUp,
                    birthData: {
                        ...state.SignUp.birthData,
                        birthPlace: {
                            ...state.SignUp.birthData.birthPlace,
                            ...action.data
                        }
                    }
                }
            };

        case Types.CHANGE_CITY_STATE:
            return {
                ...state,
                SignUp: {
                    ...state.SignUp,
                    birthData: {
                        ...state.SignUp.birthData,
                        birthPlace: {
                            ...state.SignUp.birthData.birthPlace,
                            cityState: {
                                ...state.SignUp.birthData.birthPlace.cityState,
                                ...action.data
                            }
                        }
                    }
                }
            };

        case Types.CHANGE_DATE_DATA:
            return {
                ...state,
                SignUp: {
                    ...state.SignUp,
                    birthData: {
                        ...state.SignUp.birthData,
                        birthDate: {
                            ...state.SignUp.birthData.birthDate,
                            ...action.data
                        }
                    }
                }
            };

        case Types.CHANGE_DATE_PICKER_STATE:
            return {
                ...state,
                SignUp: {
                    ...state.SignUp,
                    birthData: {
                        ...state.SignUp.birthData,
                        birthDate: {
                            ...state.SignUp.birthData.birthDate,
                            datePickerState: {
                                ...state.SignUp.birthData.birthDate.datePickerState,
                                ...action.data
                            }
                        }
                    }
                }
            };

        case Types.OPEN_DATE_PICKER: {
            const newDate = (action.data.datePickerDate as moment.Moment);
            const minDate = moment().subtract(MIN_AGE, 'years');

            const selectedDay = newDate ? newDate.format('DD') : '';
            const selectedMonth = newDate ? newDate.format('MM') : '';
            const selectedYear = newDate ? newDate.format('YYYY') : '';

            const months = (() => {
                if (!newDate) return [];

                return (newDate.format('YYYY') === minDate.format('YYYY'))
                    ? monthsArray.slice(0, minDate.month() + 1)
                    : monthsArray;
            })();

            return {
                ...state,
                SignUp: {
                    ...state.SignUp,
                    birthData: {
                        ...state.SignUp.birthData,
                        birthDate: {
                            ...state.SignUp.birthData.birthDate,
                            openDatePicker: true,
                            datePickerState: {
                                ...state.SignUp.birthData.birthDate.datePickerState,
                                datePickerDate: newDate,
                                selectedDay,
                                selectedMonth,
                                selectedYear,
                                months
                            }
                        }
                    }
                }
            };
        }

        case Types.CHANGE_HOUR_DATA:
            return {
                ...state,
                SignUp: {
                    ...state.SignUp,
                    birthData: {
                        ...state.SignUp.birthData,
                        birthHour: {
                            ...state.SignUp.birthData.birthHour,
                            ...action.data
                        }
                    }
                }
            };

        case Types.CHANGE_TIME_STATE:
            return {
                ...state,
                SignUp: {
                    ...state.SignUp,
                    birthData: {
                        ...state.SignUp.birthData,
                        birthHour: {
                            ...state.SignUp.birthData.birthHour,
                            timeState: {
                                ...state.SignUp.birthData.birthHour.timeState,
                                ...action.data
                            }
                        }
                    }
                }
            };

        case Types.CHANGE_PERSONAL_DATA:
            return {
                ...state,
                SignUp: {
                    ...state.SignUp,
                    personalData: {
                        ...state.SignUp.personalData,
                        ...action.data
                    }
                }
            };

        case Types.CHANGE_PERSONAL_FIELD_DATA: {
            const changeFieldAction = (action as IChangeFieldAction);

            return {
                ...state,
                SignUp: {
                    ...state.SignUp,
                    personalData: {
                        ...state.SignUp.personalData,
                        checkField: '',
                        [changeFieldAction.field]: {
                            ...state.SignUp.personalData[changeFieldAction.field],
                            ...changeFieldAction.data,
                            touched: (() => {
                                if (changeFieldAction.data.touched) return changeFieldAction.data.touched;

                                if (state.SignUp.personalData[changeFieldAction.field].touched) return true;

                                return changeFieldAction.data.value && changeFieldAction.data.value.length > 0;
                            })()
                        }
                    }
                }
            };
        }

        case Types.CHANGE_PERSONAL_DATA_RESET:
            return {
                ...state,
                SignUp: {
                    ...state.SignUp,
                    personalData: {
                        ...state.SignUp.personalData,
                        name: { ...initialState.SignUp.personalData.name },
                        gender: { ...initialState.SignUp.personalData.gender },
                        referencing: { ...initialState.SignUp.personalData.referencing }
                    }
                }
            };

        case Types.CLEAN_ERRORS:
            return {
                ...state,
                SignUp: {
                    ...state.SignUp,
                    birthData: {
                        ...state.SignUp.birthData,
                        birthDate: {
                            ...state.SignUp.birthData.birthDate,
                            error: ''
                        },

                        birthHour: {
                            ...state.SignUp.birthData.birthHour,
                            error: ''
                        },

                        birthPlace: {
                            ...state.SignUp.birthData.birthPlace,
                            error: ''
                        }
                    },

                    personalData: {
                        ...state.SignUp.personalData,

                        name: {
                            ...state.SignUp.personalData.name,
                            error: ''
                        },

                        email: {
                            ...state.SignUp.personalData.email,
                            error: ''
                        },

                        gender: {
                            ...state.SignUp.personalData.gender,
                            error: ''
                        },

                        password: {
                            ...state.SignUp.personalData.password,
                            error: ''
                        },

                        referencing: {
                            ...state.SignUp.personalData.referencing,
                            error: ''
                        }
                    }
                }
            };

        default:
            return state;
    }
};

const actionButton = (dispatch: Dispatch<IReducerAction>, step: string, birthDataFields?: Partial<Record<'emptyDateField' | 'emptyPlaceField' | 'emptyHourField', boolean>>) => {
    if (step === Steps.PERSONAL_DATA) {
        return dispatch({
            type: TypesContainer.CHANGE_STEP,
            data: true
        });
    }

    if (step === Steps.BIRTH_DATA && birthDataFields) {
        const emptyFieldsValidations = [];
        if (birthDataFields.emptyDateField) {
            emptyFieldsValidations.push({
                type: Types.CHANGE_DATE_DATA,
                data: { error: 'Preenchimento obrigatório.' }
            });
        }
        if (birthDataFields.emptyPlaceField) {
            emptyFieldsValidations.push({
                type: Types.CHANGE_PLACE_DATA,
                data: { error: 'Preenchimento obrigatório.' }
            });
        }
        if (birthDataFields.emptyHourField) {
            emptyFieldsValidations.push({
                type: Types.CHANGE_HOUR_DATA,
                data: { error: 'Preenchimento obrigatório.' }
            });
        }

        if (emptyFieldsValidations.length) {
            multipleActions(dispatch, [
                ...emptyFieldsValidations,
                {
                    type: TypesContainer.HANDLE_ERROR,
                    data: 'Preencha todos os campos para se cadastrar'
                }
            ]);

            return;
        }
    };

    return dispatch({
        type: TypesContainer.CHANGE_STEP,
        data: (() => {
            if (step === Steps.BIRTH_DATA) {
                return Steps.PERSONAL_DATA;
            }

            return Steps.BIRTH_DATA;
        })()
    });
};

export {
    initialState,
    actionButton,

    Types,
    ICity,
    IKeyDown,
    IInputData,
    IInputDataEmail,
    IBirthDateState,
    IBirthHourState,
    IAuthStateSignUp,
    IInputDataPassword,
    IAuthSignUpReducer,
    IPersonalDataState
};

export default SignUpReducer;
